import * as React from 'react'
import Brand from '../../../models/brand'
import BrandDealsData from '../BrandDealsData'
import BrandDetailBasicData from '../BrandDetailBasicData'
import BrandDetailAdditionalData from '../BrandDetailAdditionalData'
import { Layout } from '../../layout'
import { Grid } from '../../../components/grid'
import './detailPage.scss'

type Props = {
    brand: Brand
}

class BrandDetailPage extends React.Component<Props> {
    render() {
        const { brand } = this.props

        return (
            <Layout>
                <Grid className='brand-detail-page'>
                    <div className='row'>
                        <div className='col-xs-12 col-md-5'>
                            <BrandDetailBasicData slug={brand.slug}/>
                        </div>
                        <div className='col-xs-12 col-md-offset-1 col-md-6'>
                            <BrandDetailAdditionalData slug={brand.slug}/>
                        </div>
                    </div>
                </Grid>
                <BrandDealsData slug={brand.slug} />
            </Layout>
        )
    }
}

export default BrandDetailPage
